<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card grid-list-md>
      <ModelTitle title="Assign Subject" @close="close()" />
      <v-card-text v-if="selectedCurriculum">
        <v-row>
          <v-col cols="12" sm="12">
            <div>
              Class:
              <span class="font-weight-bold text-capitalize">{{
                selectedCurriculum.Class.name
              }}</span>
            </div>
            <div>
              Curriculum Name:
              <span class="font-weight-bold text-capitalize">{{
                selectedCurriculum.name
              }}</span>
            </div>
          </v-col>

          <v-col cols="12" sm="6">
            <v-autocomplete dense autofocus hide-details :items="Subjects" clearable item-value="id"
            item-text="name"
              v-model="selectedSubject" return-object label="Select Subject" outlined>
              <template slot="item" slot-scope="{ item }">
                <v-list-item-content>
                  <v-list-item-title class="text--primary text-capitalize" v-text="item.name">
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field outlined autofocus type="number" dense v-model="marks" label="Marks"></v-text-field>
          </v-col>
          <v-col cols="12" sm="2">
            <v-btn @click="add" :disabled="!selectedSubject || !marks" color="success">Add</v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text>
        <v-list class="list-350">
          <template v-for="(row, index) in curriculumSubjectList">
            <v-list-item :key="index">
              <v-list-item-avatar>
                <v-btn icon>
                  <v-icon color="red" @click="deleteRow(index)">delete</v-icon>
                </v-btn>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-capitalize">{{
                  row.name
                }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-content>
                <v-text-field hide-details outlined autofocus type="number" dense v-model="row.marks" label="Marks"></v-text-field>
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold ml-2" >
                Total Marks:
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action class="font-weight-bold" >
              {{totalMarks}}
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="green lighten-1" :loading="loading" dark @click="submit()">save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import curriculumService from "@/modules/ReportCard/Curriculums/service.js";
import subjectService from "@/modules/ReportCard/Subject/service.js";

export default {
  props: {
    editDialog: {
      default: false,
    },
    selectedCurriculum: {
      type: Object,
    },
  },
  name: "Assign-Class-to-student",
  data() {
    return {
      Subjects: [],
      selectedSubject: null,
      marks: 0,
      curriculumSubjectList: [],
      loading: false,
      dialog: false,
    };
  },
  watch: {
    editDialog(val) {
      this.dialog = val;
    },
    dialog(val) {
      if (val) {
        this.getSubject();
        if(this.selectedCurriculum && this.selectedCurriculum.subjectMeta && this.selectedCurriculum.subjectMeta.subjects)
        this.curriculumSubjectList = JSON.parse(JSON.stringify(this.selectedCurriculum.subjectMeta.subjects))
      }
    },
  },
  computed: {
    totalMarks(){
      let marks = 0
      this.curriculumSubjectList.map(row => {
        marks += parseInt(row.marks)
      })
      return marks
    }
  },
  methods: {
    deleteRow(i) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          this.curriculumSubjectList.splice(i, 1);
        }
      });
    },
    add() {
      let subjectFound = false
      this.curriculumSubjectList.map(row => {
        if(row.id === this.selectedSubject.id){
          subjectFound = true
        }
      })
      if(subjectFound){
        this.$swal
        .mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        })
        .fire({
          icon: "error",
          title: 'Subject already Assigned to this curriculum',
        });
        return true
      }
      let obj = {
        id: this.selectedSubject.id,
        marks: this.marks,
        name: this.selectedSubject.name,
      };
      this.curriculumSubjectList.push(obj);
      this.selectedSubject = null;
      this.marks = null;
    },
    getSubject() {
      return subjectService.getAll().then((response) => {
        this.Subjects = response.data;
        console.log("response Subjects", this.Subjects);
        return response;
      });
    },
    submit(){
      if(this.totalMarks !== 100){
        this.$swal
        .mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        })
        .fire({
          icon: "error",
          title: 'Total marks should be equal to 100',
        });
        return true
      }
      this.selectedCurriculum.subjectMeta = {
        subjects: this.curriculumSubjectList
      }
      curriculumService
        .update(this.selectedCurriculum.id, this.selectedCurriculum)
        .then((result) => {
          if(result){
            this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "success",
              title: "Subjects assigned to this curriculum",
            });
            this.empty();
            this.$emit("submit");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: err.data.message,
            });
        });
    },
    close() {
      this.$emit("close");
      this.empty();
    },
    empty() {
      this.selectedSubject = null;
      this.marks = 0;
    },
  },
};
</script>

<style scoped></style>
